import {
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Guid } from 'guid-typescript';

// TODO: types+functions should be separated [ future release ]
export type InlineItem<T> = {
  id: string;
  new: boolean;
  details: T;
};

export function inlineItem<T>(
  id: string,
  isNew: boolean,
  details: T
): InlineItem<T> {
  return {
    id: id,
    new: isNew,
    details: details
  };
}

export function inlineItemNew<T>(x: T): InlineItem<T> {
  return inlineItem(Guid.create().toString(), true, x);
}

export function inlineItemExisting<T>(id: string, x: T): InlineItem<T> {
  return inlineItem(id, false, x);
}

@Directive({
  selector: 'inline-summary'
})
export class InlineSummary {}

@Directive({
  selector: 'inline-content'
})
export class InlineContent {}

@Component({
  selector: 'app-inline-item',
  templateUrl: './inline-item.component.html',
  styleUrls: ['./inline-item.component.scss']
})
export class InlineItemComponent implements OnInit {
  @Input()
  form!: AbstractControl;

  @Input()
  initiallyExpanded: boolean = false;

  @Input()
  isExpandable: boolean = true;

  @Input()
  isRemovable: boolean = true;

  @Output()
  delete: EventEmitter<void> = new EventEmitter<void>();

  private collapse: boolean = true;

  constructor() {}

  ngOnInit(): void {
    this.collapse = this.isExpandable && !this.initiallyExpanded;
  }

  public get isCollapsed(): boolean {
    return this.collapse;
  }

  public get showValidation(): boolean {
    return this.isCollapsed && this.form.invalid && this.form.touched;
  }

  public onClickRemove(): void {
    this.delete.emit();
  }

  public onToggleExpand(): void {
    if (this.isExpandable) {
      this.collapse = !this.collapse;
    }
  }
}
